import rehypeMinifyWhitespace from 'rehype-minify-whitespace';
import rehypeParse from 'rehype-parse';
import { unified } from 'unified';

import { Trace } from '@gitbook/util-debug';

import { createParsingContext } from '../context';
import { defaultParsingOptions, type ParsingOptions } from '../options';
import { type HastToGastResult, hastToGast } from './hastToGast';

/**
 * Parse a HTML string into a GitBook document.
 */
export function parseHTML(
    input: string,
    options: ParsingOptions = defaultParsingOptions
): Promise<HastToGastResult> {
    const trace = new Trace('format.parseHTML', { silent: true, sampleRate: 0 });
    const context = createParsingContext(options);

    return trace.wrap(async () => {
        const file = await unified()
            // Parse the HTML
            .use(rehypeParse)
            .use(rehypeMinifyWhitespace)
            // Transform the HTML tree into a document
            .use(hastToGast, context)
            .process(input);

        // @ts-expect-error
        const { document, attributes } = await file.result;

        return {
            document,
            attributes,
        };
    });
}
